
import { mdiDomain, mdiEye, mdiFaceMan } from "@mdi/js"
export default {
    name: "UserStatistics",
    components: {
        OabatDashboardGraph: () =>
            import("@/components/statistics/OabatDashboardGraph"),
        DashboardStatisticsTable: () =>
            import("@/components/statistics/DashboardStatisticsTable"),
        AdminBusinessList: () =>
            import("@/components/admin/business/AdminBusinessList"),
        AdminSchoolList: () =>
            import("@/components/admin/business/AdminSchoolList"),
        AdminRegionList: () =>
            import("@/components/admin/business/AdminRegionList"),
    },
    emits: ["refresh"],
    props: {
        statisticsData: {
            type: Object,
            default: null,
        },
        basicChartOptions: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        tabs: null,
        mdiFaceMan,
        mdiDomain,
        mdiEye,
    }),
    computed: {
        tableEntries() {
            if (!this.statisticsData) {
                return []
            }
            return [
                {
                    label: "Azubi-Account",
                    icon: mdiFaceMan,
                    value: this.statisticsData.traineesVerified,
                },
                {
                    label: "Unternehmen",
                    icon: mdiDomain,
                    value: this.statisticsData.businessesVerified,
                },
                {
                    label: "Sichtbare Unternehmen",
                    icon: mdiEye,
                    value:
                        this.statisticsData.latestRecord?.visible_businesses +
                        " (7 Tage-Differenz: " +
                        (this.statisticsData.latestRecord?.visible_businesses -
                            this.statisticsData.lastWeekRecord
                                ?.visible_businesses) +
                        ")",
                },
            ]
        },
        chartOptions() {
            let options = this.basicChartOptions
            options.title.text = "User-Statistik"
            options.color = ["#38dbb6", "#3b54ab", "#38dbb6"]
            options.yaxis = [
                {
                    title: { text: "Sichtbare Betriebe" },
                    seriesName: "Sichtbare Betriebe",
                },
                {
                    opposite: true,
                    title: { text: "Neu dazugekommen" },
                    seriesName: "Neue Betriebe",
                },
                // share the same y-axis for new businesses and students
                {
                    opposite: true,
                    show: false,
                    seriesName: "Neue Betriebe",
                },
            ]
            return options
        },
        graphData() {
            let series = []
            if (this.statisticsData) {
                series.push({ name: "Sichtbare Betriebe", data: [] })
                series.push({ name: "Neue Betriebe", data: [] })
                series.push({ name: "Neue Schüler", data: [] })
                for (const value of Object.values(
                    this.statisticsData.statistics
                )) {
                    series[0].data.push(value.visible_businesses)
                    series[1].data.push(value.businesses)
                    series[2].data.push(value.trainees)
                }
            }
            return series
        },
    },
    methods: {
        refreshData(params) {
            this.$emit("refresh", params)
        },
    },
}
